import React from 'react'
import Navbar from '../components/navbar/Navbar'
import Topbar from '../components/topbar/Topbar'
import { Outlet, useLocation } from 'react-router-dom'
import './CommonLayout.scss';

function CommonLayout() {
  const location = useLocation();
  const isChat = location.pathname === "/chat";

  return (
    <div className={`common_layout ${isChat ? "chat_mode" : ""}`}>
      <Navbar />
      <div className="main_content">
        <div>
          <Topbar />
        </div>
        <div className="page_content">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default CommonLayout